interface FormFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: string;
  error?: string;
  hint?: string;
}

/**
 * Champ de formulaire libellé, compatible `register()` de react-hook-form
 * (React 19 : `ref` arrive comme une prop ordinaire).
 */
export const FormField = ({ id, label, error, hint, className, ...rest }: FormFieldProps) => (
  <div className="flex flex-col gap-1.5">
    <label htmlFor={id} className="text-xs font-medium text-zinc-700">
      {label}
    </label>
    <input
      id={id}
      aria-invalid={error ? true : undefined}
      aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
      className={[
        'h-10 w-full px-3 text-sm bg-white border rounded-md text-zinc-900 placeholder:text-zinc-400 transition-colors',
        'focus:outline-none focus:ring-2',
        error
          ? 'border-red-400 focus:border-red-500 focus:ring-red-100'
          : 'border-zinc-300 focus:border-zinc-400 focus:ring-zinc-900/10',
        className ?? '',
      ].join(' ')}
      {...rest}
    />
    {error ? (
      <p id={`${id}-error`} className="text-xs text-red-600">
        {error}
      </p>
    ) : hint ? (
      <p id={`${id}-hint`} className="text-xs text-zinc-500">
        {hint}
      </p>
    ) : null}
  </div>
);
